import { z } from "zod";
import { SystemEntity } from "@erp/shared-types";

export const SystemEntitySchema = z.object({
  entityType: z.nativeEnum(SystemEntity),
  entityId: z.uuid(),
});

const looseUuidString = z.uuid();

/**
 * Workflow wiring and manual triggers sometimes pass a bare UUID where the
 * schema expects `{ entityType, entityId }` (e.g. legacy test cases, JSON
 * pasted in the event tester). Normalize before validating.
 */
function coerceStringToEntityRef<T extends SystemEntity>(
  expectedType: T,
  val: unknown,
): unknown {
  if (typeof val !== "string") return val;
  const trimmed = val.trim();
  if (!trimmed) return val;
  if (!looseUuidString.safeParse(trimmed).success) return val;
  return { entityType: expectedType, entityId: trimmed };
}

// Small factory for specializations
export const entityOfType = <T extends SystemEntity>(type: T) =>
  z.preprocess(
    (val) => coerceStringToEntityRef(type, val),
    SystemEntitySchema.extend({ entityType: z.literal(type) }),
  );
